// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/period_schedule.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schedules_v1_resources_period } from "./period_pb.js";

/**
 * Describes the file studyo/today/schedules/v1/resources/period_schedule.proto.
 */
export const file_studyo_today_schedules_v1_resources_period_schedule = /*@__PURE__*/
  fileDesc("CjlzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9wZXJpb2Rfc2NoZWR1bGUucHJvdG8SI3N0dWR5by50b2RheS5zY2hlZHVsZXMudjEucmVzb3VyY2VzIqgBCg5QZXJpb2RTY2hlZHVsZRIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEjwKB3BlcmlvZHMYAyADKAsyKy5zdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcy5QZXJpb2QSFQoNc2NoZWR1bGVfdGFncxgEIAMoCRIQCghyZXZpc2lvbhgFIAEoBRIVCg1zaG91bGRfZGVsZXRlGAYgASgIQiuqAihTdHVkeW8uVG9kYXkuU2NoZWR1bGVzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_studyo_today_schedules_v1_resources_period]);

/**
 * Describes the message studyo.today.schedules.v1.resources.PeriodSchedule.
 * Use `create(PeriodScheduleSchema)` to create a new message.
 */
export const PeriodScheduleSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_period_schedule, 0);

